// Ana sayfanın "Öne Çıkan Maçlar" şeridinin yardımcıları.
//
// Maçlar Digitain'in öne çıkan maç ucundan gelir (backend
// services/sportdigi_matches.py) ve yalnızca **vitrindir**: hazır spor
// kitabının kuponu sağlayıcının kendi çerçevesinde oluşur, bizim sayfamızdan
// ona seçim eklenemez. Karta dokunmak spor sayfasını Digitain seçili açar.
import { hostedSportsbooks, sportsbookHref } from './sportsbookProviders';

export const TOP_MATCHES_PROVIDER = 'sportdigi';
export const TOP_MATCHES_ENDPOINT = '/sportdigi-sportsbook/top-matches';

/** Şerit çizilebilir mi: spor açık ve Digitain yayındaki spor kitapları arasında. */
export const topMatchesAvailable = (settings) => (
  settings?.sports_enabled !== false
  && hostedSportsbooks(settings).some((row) => row.id === TOP_MATCHES_PROVIDER)
);

export const matchHref = (match) => sportsbookHref(TOP_MATCHES_PROVIDER, match?.path);

const TIME_ZONE = 'Europe/Istanbul';

// Parçalar elle birleştirilir: `toLocaleDateString` ayraçları tarayıcının ICU
// verisine bağlıdır ("01.10" bir ortamda "01/10" yazıyordu).
const zonedParts = (date) => {
  const parts = {};
  new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date).forEach(({ type, value }) => { parts[type] = value; });
  return parts;
};

const dayKey = (parts) => `${parts.year}-${parts.month}-${parts.day}`;

/**
 * Başlama zamanı — Türkiye saatiyle "Bugün 21:45", "Yarın 19:00" ya da
 * "01.10 21:45". Zaman çözülemezse boş döner; uydurma bir saat yazılmaz.
 */
export const formatMatchTime = (value, now = new Date()) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = zonedParts(date);
  const time = `${parts.hour}:${parts.minute}`;
  const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
  if (dayKey(parts) === dayKey(zonedParts(now))) return `Bugün ${time}`;
  if (dayKey(parts) === dayKey(zonedParts(tomorrow))) return `Yarın ${time}`;
  return `${parts.day}.${parts.month} ${time}`;
};

export const formatOdd = (price) => Number(price || 0).toFixed(2);
